<template>
	<div class="page-properties" ref="page_properties">
		<div class="verified-properies-wrap">
			<div class="verified-properies-wrap-title">
				<div class="verified-properies-wrap-title-box">
					<h1 class="section-title section-title--verified-properies">Verified Notification</h1>
				</div>
				<div class="verified-property-checkbox verified-property-checkbox--agent">
					<PartCheckboxDropdown
						v-model="verifiedPropertyAgent"
						:data="DataAgent"
						@input="verifiedChange(verifiedPropertyAgent, 'agent')"
					/>
				</div>
				<div class="verified-property-checkbox">
					<PartCheckboxDropdown
						v-model="verifiedProperty"
						:data="verifiedPropertyData"
						@input="verifiedChange(verifiedProperty, 'period')"
					/>
				</div>
			</div>
			<div class="notification-wrap-middle">
				<PartNotifications :data="notificationsData" v-if="notificationsData.msg" />
			</div>
			<div class="table-wrap" :class="{'table-empty': noResults}">
				<BlockTable
					v-if="!noResults"
					:data="DashboardPropertiesData"
					class="verified-properies-table style-table--round"
					@sortData="sortProperties"
					@PropertyHistoryOrEdit="PropertyHistoryOrEdit"
					@sendEmail="sendEmail"
					:sort="localOrderBy"
				/>

				<PartLoaderBig class="loader-table" v-if="preloader"/>
				<PartNoResults :data="DataNoResults" v-if="noResults && !preloader"/>

				<PartPagination
					ref="pagination"
					v-show="!preloader && showPagination"
					@getPage="getPage"
				/>
			</div>
		</div>
		<PartPopupDelete
			v-if="showPopupDelete"
			:data="PopupDelete"
			@confirmPopupDelete="confirmPopupDelete"
			@closePopupDelete="closePopupDelete"
		>
			<template v-slot:popupTitle>Are you sure you want to delete this item?</template>
			<template v-slot:popupCancel>No</template>
			<template v-slot:popupConfirm>Yes</template>
		</PartPopupDelete>
	</div>
</template>
<script>
import BlockTable from '@/components/blocks/BlockTable';
import PartPopupDelete from '@/components/parts/PartPopupDelete';
import PartLoaderBig from '@/components/parts/PartLoaderBig';
import PartPagination from '@/components/parts/PartPagination';
import PartNotifications from '@/components/parts/PartNotifications';
import PartNoResults from '@/components/parts/PartNoResults';
import PartCheckboxDropdown from '@/components/parts/PartCheckboxDropdown';
import { check } from '@/services/RouteGuards/Admin';

export default {
	data: () => {
		return {
			DataNoResults: {},
			noResults: true,
			notificationsData: {
				type: '',
				msg: ''
			},
			localOrder: 'asc',
			localOrderBy: 'title',
			showPagination: false,
			preloader: true,
			PopupDelete: {
				itemID: ''
			},
			verifiedProperty: '',
			verifiedPropertyAgent: '',
			showPopupDelete: false,
			classScroll: 'prevent-scroll',
			DashboardPropertiesData: {
				stickyHeader: true,
				noLocalSorting: true,
				noCollapse: false,
				fields: [
					{ key: 'title', label: 'Property', sortable: true, stickyColumn: true, variant: 'property thead-lg' },
					{ key: 'date_listed', label: 'Date Listed', sortable: true, stickyColumn: true, variant: 'listing-status' },
					{ key: 'date_verified', label: 'Date Verified', sortable: true, stickyColumn: true, variant: 'date-verified' },
					{ key: 'verification_overdue', label: 'Overdue', sortable: true, stickyColumn: true, variant: 'overdue' },
					{ key: 'verification_notification_date', label: 'Last Sent', sortable: true, stickyColumn: true, variant: 'last' },
					{ key: 'agent_name', label: 'Agent', sortable: true, stickyColumn: true, variant: 'building-size' },
					{ key: 'btn', label: '', sortable: false, stickyColumn: true, variant: 'fixed-icon table-fixed-icon--button email-btn first-icon-fixed' }
				],
				items: []
			},
			verifiedPropertyData: {
				label: 'Overdue by',
				placeholder: 'Add overdue',
				labelId: 'overdue-label',
				inputId: 'overdue-input',
				searchable: true,
				mandatoryFiled: false,
				options: [
					{
						id: '3-5',
						label: '3-5 months'
					},
					{
						id: '6-11',
						label: '6-11 months'
					},
					{
						id: '12-12',
						label: '12 months or more'
					}
				],
				multiple: true
			},
			DataAgent: {
				label: 'Assigned Agent',
				labelId: 'user-commercial-label',
				inputId: 'user-commercial-input',
				placeholder: 'Add Agent',
				mandatoryFiled: false,
				options: [],
				multiple: true
			},
			chosenPeriod: '',
			chosenAgents: ''
		};
	},
	components: {
		BlockTable,
		PartPopupDelete,
		PartLoaderBig,
		PartPagination,
		PartNotifications,
		PartNoResults,
		PartCheckboxDropdown
	},
	created() {
		// Init sort by date verified
		const obj = {
			order_by: this.localOrderBy,
			order: this.localOrder,
			page: 1
		};

		this.$store.dispatch('verifiedProperties', obj).then(response => {
			this.$refs.pagination.updateDataPag(response.data);
			this.checkPagination(response.data);
		});

		const dropFields = ['agents'];
		this.$store.dispatch('fetchDropDownOptions', { values: dropFields }).then((res) => {
			const data = res.data;
			this.DataAgent.options = data.agents;
		});
	},
	computed: {
		properties() {
			return this.$store.getters.getVerifiedProperties;
		}
	},
	watch: {
		properties() {
			this.noResults = !this.properties.length;
			this.preloader = false;
			const arr = [];
			this.properties.forEach((ele) => {
				if (ele.listing_status_label === 'In Contract') {
					ele._rowVariant = 'in-contract';
				}
				arr.push(ele);
			});
			this.DashboardPropertiesData.items = arr;
		}
	},
	methods: {
		PropertyHistoryOrEdit(id, target) {
			if (!this.checkPermissions()) {
				const routePropertyHistoryOrEdit = this.$router.resolve({ name: 'PropertyHistoryAdmin', params: { id: id } });
				window.open(routePropertyHistoryOrEdit.href, target);
			} else {
				const routePropertyHistoryOrEdit = this.$router.resolve({ name: 'EditProperty', params: { id: id } });
				window.open(routePropertyHistoryOrEdit.href, target);
			}
		},
		notification(response) {
			this.notificationsData.msg = response.data.message;
			this.notificationsData.type = response.status === 200 ? 'success' : 'danger';

			setTimeout(() => {
				this.notificationsData.msg = '';
				this.notificationsData.type = '';
			}, 2000);
		},
		fetchNewActiveProperties(obj) {
			// setTimeout(() => {
			this.preloader = true;
			// }, 100);

			return this.$store.dispatch('verifiedProperties', obj);
		},
		sortProperties(item) {
			const obj = {
				order_by: item,
				order: this.SortOrder(item),
				page: 1,
				period: this.chosenPeriod,
				agents: this.chosenAgents
			};
			this.localOrderBy = item;
			this.fetchNewActiveProperties(obj).then(response => {
				this.$refs.pagination.updateDataPag(response.data);
				this.preloader = false;
			});
		},
		SortOrder(item) {
			if (this.localOrderBy === item) {
				if (this.localOrder === 'asc') {
					this.localOrder = 'desc';
				} else {
					this.localOrder = 'asc';
				}
			} else {
				this.localOrder = 'asc';
			}
			return this.localOrder;
		},
		getPage(page, $ref) {
			const obj = {
				order_by: this.localOrderBy,
				order: this.localOrder,
				page: page,
				period: this.chosenPeriod,
				agents: this.chosenAgents
			};
			this.fetchNewActiveProperties(obj).then(response => {
				$ref.updateDataPag(response.data);
				this.preloader = false;
			});
		},
		checkPagination(data) {
			this.showPagination = data.prev_page_url !== null || data.next_page_url !== null;
		},
		verifiedChange(val, flag) {
			if (flag === 'period') {
				this.chosenPeriod = val;
			} else {
				this.chosenAgents = val;
			}

			const obj = {
				period: this.chosenPeriod,
				agents: this.chosenAgents
			};
			this.$store.dispatch('verifiedProperties', obj).then(response => {
				this.$refs.pagination.updateDataPag(response.data);
				this.checkPagination(response.data);
			});
		},
		sendEmail(item) {
			const obj = {
				agent_id: item.agent,
				property_id: item.id
			};
			this.$store.dispatch('sendVerificationEmail', obj).then(res => {
				if (res.data.status === 'verification_mail_sent_successfully') {
					this.properties.forEach(el => {
						if (el.id === item.id) {
							el.disable_mail_button = true;
							el.verification_notification_date = res.data.last_sent;
							el.sentEmailAgain = true;
						}
					});
				} else {
					this.notification(res);
				}
			});
		},
		checkPermissions() {
			return check();
		}
	}
};
</script>
<style lang="scss" scoped>
.verified-properies-wrap-title {
	display: flex;
	align-items: center;
	margin-bottom: 29px;
	position: relative;
	justify-content: space-between;

	@include mq(1300px) {
		flex-wrap: wrap;
	}

	@include mq(560px) {
		flex-direction: column;
		justify-content: center;
		margin-bottom: 0;
	}
}

.verified-property-checkbox {
    max-width: 350px;
	width: 100%;
    margin-left: 15px;
	z-index: 100;

	&--agent {
		z-index: 1000;
	}

	@include mq(1440px) {
		max-width: 280px;
	}

	@include mq(850px) {
		margin: 0 auto;
		max-width: 250px;
	}
}

.verified-properies-wrap-title-box {
	display: flex;
	align-items: center;
	position: relative;
	margin-right: auto;

	@include mq(850px) {
		justify-content: center;
		width: 100%;
		margin-right: 0;
		margin-bottom: 15px;
	}
}

.page-properties {
	max-width: 100%;
	width: 100%;
	padding: 43px 35px 43px 0;

	@include mq(1500px) {
		padding: 43px 15px;
	}

	@include mq(1200px) {
		max-width: 100%;
	}

	@include mq($xl) {
		padding: 20px 0;
	}
}

.verified-properies-table {
    max-width: 100%;
	margin: 0;

	/deep/
	td:first-of-type {

	}

	/deep/
	.img-link__image {
		width: 50px;
		min-width: 50px;
		background-color: #e8eaee !important;

		.table__img {
			width: 100% !important;
			flex: 0 0 auto !important;
			max-width: 100% !important;
		}
	}

	/deep/
	.property-img__inner-title a {
		max-width: none;
	}

	/deep/
	.property-img__btn {
		display: none;
	}

	/deep/
	.property-img-cell-wrap {
		margin: 0;
	}
}

.section-title--verified-properies {
	margin: 0 24px 0 2px;
	white-space: nowrap;
}

.dashboard-properties-wrap__header {
	display: flex;
	margin: 0;
	width: 100%;
}

.dashboard-properties-wrap__header-link {
	font-family: $font-main;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	color: $shuttle-gray;
	display: flex;
    justify-content: center;
    align-items: center;
    padding: 13px;
	transition: $dur $ease;
	text-decoration: none;
	max-width: 33.3%;
	flex: 0 0 33.3%;
	width: 100%;
	position: relative;
	background-color: $white-lilac;

	@include mq($md) {
		font-size: 14px;
	}

	@include mq(670px) {
		padding: 10px;
		flex-direction: column;
	}

	&::after {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		background-color: $selago;
		width: 1px;
		height: 100%;
		opacity: 0.4;
		transition: $dur $ease;
	}

	&:first-of-type {
		border-top-left-radius: 14px;
	}

	&:last-of-type {
		border-top-right-radius: 14px;
		&::after {
			display: none;
		}
	}

	&.is-active-link {
		background-color: $link-water;
		color: $dodger-blue;
	}

	@include hover {
		background-color: $link-water;
		color: $dodger-blue;
	}
}

.dashboard-properties-wrap__icon {
	display: inline-block;
    padding-right: 7px;
	font-size: 14px;
	height: 20px;

	@include mq(670px) {
		display: none;
	}

	svg {
		display: block;
		height: 14px;
	}
}

.dashboard-properties-wrap__icon--list {
	font-size: 11px;
	height: 20px;
}

.dashboard-properties-wrap__header-inner {
	@include mq(460px) {
		flex-direction: column;
		display: flex;
	}
}

.notification-wrap-middle {
	position: relative;
	transform: none;
	left: auto;
	top: auto;
	width: 100%;
	align-items: center;
	justify-content: center;
	display: flex;

	@include mq(1300px) {
		order: 3;
	}
}
</style>
